







import { Component, Vue, Watch } from 'vue-property-decorator';
import layout from '@/layouts/app-layout.vue';
import breadcrumb from '@/components/breadcrumb.vue';

@Component({
    components: {
        layout,
        breadcrumb,
    },
})
export default class Enquiries extends Vue {
}

